import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/npm': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 288h-32v-64h32v64zM576 160v192h-288v32h-128v-32h-160v-192h576zM160 192h-128v128h64v-96h32v96h32v-128zM320 192h-128v160h64v-32h64v-128zM544 192h-192v128h64v-96h32v96h32v-96h32v96h32v-128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/npm.js
// module id = null
// module chunks = 